var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333008 13.0026C0.333008 12.6344 0.631485 12.3359 0.999674 12.3359H12.9997C13.3679 12.3359 13.6663 12.6344 13.6663 13.0026C13.6663 13.3708 13.3679 13.6693 12.9997 13.6693H0.999674C0.631485 13.6693 0.333008 13.3708 0.333008 13.0026Z",
    fill: "#818181"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33301 4.33594C4.33301 3.96775 4.63148 3.66927 4.99967 3.66927H5.66634C6.03453 3.66927 6.33301 3.96775 6.33301 4.33594C6.33301 4.70413 6.03453 5.0026 5.66634 5.0026H4.99967C4.63148 5.0026 4.33301 4.70413 4.33301 4.33594Z",
    fill: "#818181"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33301 7.0026C4.33301 6.63441 4.63148 6.33594 4.99967 6.33594H5.66634C6.03453 6.33594 6.33301 6.63441 6.33301 7.0026C6.33301 7.37079 6.03453 7.66927 5.66634 7.66927H4.99967C4.63148 7.66927 4.33301 7.37079 4.33301 7.0026Z",
    fill: "#818181"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33301 9.66927C4.33301 9.30108 4.63148 9.0026 4.99967 9.0026H5.66634C6.03453 9.0026 6.33301 9.30108 6.33301 9.66927C6.33301 10.0375 6.03453 10.3359 5.66634 10.3359H4.99967C4.63148 10.3359 4.33301 10.0375 4.33301 9.66927Z",
    fill: "#818181"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66634 4.33594C7.66634 3.96775 7.96482 3.66927 8.33301 3.66927H8.99967C9.36786 3.66927 9.66634 3.96775 9.66634 4.33594C9.66634 4.70413 9.36786 5.0026 8.99967 5.0026H8.33301C7.96482 5.0026 7.66634 4.70413 7.66634 4.33594Z",
    fill: "#818181"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66634 7.0026C7.66634 6.63441 7.96482 6.33594 8.33301 6.33594H8.99967C9.36786 6.33594 9.66634 6.63441 9.66634 7.0026C9.66634 7.37079 9.36786 7.66927 8.99967 7.66927H8.33301C7.96482 7.66927 7.66634 7.37079 7.66634 7.0026Z",
    fill: "#818181"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66634 9.66927C7.66634 9.30108 7.96482 9.0026 8.33301 9.0026H8.99967C9.36786 9.0026 9.66634 9.30108 9.66634 9.66927C9.66634 10.0375 9.36786 10.3359 8.99967 10.3359H8.33301C7.96482 10.3359 7.66634 10.0375 7.66634 9.66927Z",
    fill: "#818181"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66634 1.66927C3.48953 1.66927 3.31996 1.73951 3.19494 1.86453C3.06991 1.98956 2.99967 2.15913 2.99967 2.33594V13.0026C2.99967 13.3708 2.7012 13.6693 2.33301 13.6693C1.96482 13.6693 1.66634 13.3708 1.66634 13.0026V2.33594C1.66634 1.8055 1.87705 1.2968 2.25213 0.921724C2.6272 0.546651 3.13591 0.335938 3.66634 0.335938H10.333C10.8634 0.335938 11.3721 0.546651 11.7472 0.921724C12.1223 1.2968 12.333 1.8055 12.333 2.33594V13.0026C12.333 13.3708 12.0345 13.6693 11.6663 13.6693C11.2982 13.6693 10.9997 13.3708 10.9997 13.0026V2.33594C10.9997 2.15913 10.9294 1.98956 10.8044 1.86453C10.6794 1.73951 10.5098 1.66927 10.333 1.66927H3.66634Z",
    fill: "#818181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/hotel.e3b210778cd90ed3ffd0655534a3050e.svg";
export { ForwardRef as ReactComponent };